import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";

import {HttpClient, HttpParams} from "@angular/common/http";
import {map, Observable} from "rxjs";



@Injectable({
  providedIn: 'root'
})
export class EventContactsService {
  baseURL = environment.baseUrl + 'eventContact';

  constructor(private http: HttpClient) {
  }


  getAllEventContacts(eventId:any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/getAll/event/${eventId}`)
  }

  saveEventContacts(eventId:any,body:any): Observable<any>{
    return this.http.post<any>(`${this.baseURL}/event/${eventId}`,body).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  deleteEventContact(eventId:any,id:any): Observable<any>{
    return this.http.delete<any>(`${this.baseURL}/delete/event/${eventId}`,{
      params:new HttpParams()
        .append('id',id)
    })
  }
}
